import _extends from "babel-runtime/helpers/extends";
var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('pt-select', _vm._g(_vm._b({ attrs: { "autoWidth": "", "ghost": "", "popper-class": "web-previewer-popper", "value": _vm.value, "placeholder": _vm.placeholder } }, 'pt-select', _extends({}, _vm.$attrs, _vm.$props), false), _vm.$listeners), _vm._l(_vm.mapData(_vm.data, _vm.languageList), function (group, index) {
    return _c('pt-option-group', { key: index, attrs: { "label": group.label } }, _vm._l(group.options, function (item) {
      return _c('pt-option', { key: item.value, attrs: { "label": item.label, "value": item.value } }, [_c('icon-language', { attrs: { "code": item.value } })], 1);
    }), 1);
  }), 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };